<template>
    <div id="univer-group" class="univer-group page">
        <div class="univer-group__header">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12 col-xl-10 offset-xl-1">
                        <h1>{{ currentUniverGroup.name }}</h1>
                        <div class="text" v-html="currentUniverGroup.short_description"></div>
                    </div>
                </div>
            </div>            
        </div>
        <div class="univer-group__sub-menu">
            <div class="container-xl">
                <div class="row univer-group__sub-categories-menu-wrap">
                    <div class="col-12 col-md-4 col-lg-3 univer-group__sub-categories-wrap" v-for="category in currentCategorySubCategories" :key="category.id">
                        <div class="univer-group__sub-categories-item" @click="GTMProdCatClick(category.name)">
                            <router-link  v-if="!hasHttp( category.slug)" :to="{ name:'UniverGroupSubCategoryPage', params: {group_slug: category.slug}}">
                                <div class="name">{{ category.name }}</div>
                                <div class="short-desc">{{category.short_description}}</div>
                            </router-link>
                            <a v-else target="_blank" :href="category.slug">
                                <div class="name">{{ category.name }}</div>
                                <div class="short-desc">{{category.short_description}}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="univer-group__content">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12">
                        <div class="description" v-html="currentUniverGroup.description">{{ currentUniverGroup.description }}</div>
                    </div>
                </div>
            </div>           
        </div>
        <div class="univer-group__related-docs" v-if="relatedDocs.length > 0">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12">
                        <h3>{{ lang('univer_group_kapcsolodo_dokumentumok')}}</h3>
                    </div>
                </div>
                <div class="row" >
                    <div class="col-12 col-xl-10 offset-xl-1">
                        <div class="row">
                            <div class="col-12 col-md-6 univer-group-main" v-for="doc in relatedDocs" :key="doc.id">
                                <RelatedDosc :name="doc.name" :slug="doc.document_id.path" :file_name="doc.document_id.file_name" />
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
console.log('ola1');
import axios from 'axios'
import RelatedDosc from '@/components/pagesComponents/univerGroup/RelatedDocs.vue'

export default {
    data(){
        return {
            currentUniverGroup: {},
            currentCategorySubCategories: [],
            relatedDocs: [],
            currentCategoryMetas: {
                meta_description: null,
                meta_image: null,
                meta_keywords: null,
                meta_title: null
            }   
        }
    },
    components:{
        RelatedDosc
    },
    watch:{         
        $route: function(){                
            this.getCurrentUniverGroup();           
        }                    
    },
    computed:{
        currentGroupCategorySlug(){
            return this.$route.params.main_group;
        }
    },
    methods:{
        getCurrentUniverGroup(){
            let _this = this;                    

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/category/' + _this.currentGroupCategorySlug + '?relations=1&relations_params[download][where][0][0]=where&relations_params[download][where][0][1]=status&relations_params[download][where][0][2]=1&relations_params[download][order_by][0][0]=sort_order&relations_params[download][order_by][0][1]=asc&relations_params[sub_categories][where][0][0]=where&relations_params[sub_categories][where][0][1]=status&relations_params[sub_categories][where][0][2]=1&relations_params[sub_categories][order_by][0][0]=sort_order&relations_params[sub_categories][order_by][0][1]=asc',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                // console.log(response.data)
                if (response.data.status == true ){                    

                    if ( parseInt(response.data.category[0].status) === 1){
                        //active category
                        _this.currentUniverGroup = response.data.category[0]

                        //subcategories
                        if (response.data.category[0].sub_categories){
                           // _this.currentCategorySubCategories = response.data.category[0].sub_categories  
                            _this.currentCategorySubCategories = [];
                             if (_this.$store.state.needPD){
                                 
                                for (var i=0; i <response.data.category[0].sub_categories.length ;i++)
                                {
                                    if (response.data.category[0].sub_categories  [i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                                          _this.currentCategorySubCategories.push(response.data.category[0].sub_categories  [i]);
                                }
                                
                            }
                            else
                                 _this.currentCategorySubCategories = response.data.category[0].sub_categories ;     
                        } else {
                            _this.currentCategorySubCategories = []
                        }

                        //related docs
                        if ( response.data.category[0].download){
                            _this.relatedDocs =  response.data.category[0].download
                        } else {
                            _this.relatedDocs = []
                        }

                        //meta tags
                        if (response.data.category[0].meta_description != ''){
                            _this.currentCategoryMetas.meta_description = response.data.category[0].meta_description
                        } else {
                            _this.currentCategoryMetas.meta_description = null
                        }                       

                        if ( !response.data.category[0].meta_image ) {  
                            _this.currentCategoryMetas.meta_image = null
                        } else {
                            let meta_image_src = process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME + '/' + response.data.category[0].meta_image.path + response.data.category[0].meta_image.file_name
                            _this.currentCategoryMetas.meta_image = meta_image_src
                        }
                        
                        if (response.data.category[0].meta_keywords != ''){
                            _this.currentCategoryMetas.meta_keywords = response.data.category[0].meta_keywords
                        } else {
                            _this.currentCategoryMetas.meta_keywords = null
                        }
                        
                        if (response.data.category[0].meta_title != '') {
                            _this.currentCategoryMetas.meta_title = response.data.category[0].meta_title
                        } else {
                            _this.currentCategoryMetas.meta_title = null
                        }          
                        
                        _this.setCurrentMetaTags() 

                    } else {
                        //the category isn't active
                        this.$router.push({name: '404-page'})
                    }                                                           
                } else {
                    this.$router.push({name: '404-page'})
                }                                                              
            })
            .catch((err) => {
                console.log(err)
            }); 
        },
        setCurrentMetaTags(){
            let _this = this            

            this.setMetaTags({
                title: _this.currentCategoryMetas.meta_title, 
                desc: _this.currentCategoryMetas.meta_description, 
                keywords: _this.currentCategoryMetas.meta_keywords, 
                ogType: 'article', 
                ogTitle: _this.currentCategoryMetas.meta_title,
                ogImage: _this.currentCategoryMetas.meta_image, 
                ogImageWidth: null, 
                ogImageHeight: null, 
                ogDesc: _this.currentCategoryMetas.meta_description
            })
        },
        GTMProdCatClick(menuitem){          
            this.setDataLayer(this.currentUniverGroup.name, menuitem, '')                  
        }         
    },
    created(){
        this.getCurrentUniverGroup();         
    }
}
</script>